import { Button, ButtonProps } from "@mui/material";

// We should wrap a span on the button children to avoid problems with Google translate
export const LoadingButton = (props: ButtonProps) => (
  <Button variant="contained" {...props}>
    <span>{props.children}</span>
  </Button>
);
